import CampaignService from './Campaign.service'
export default CampaignService
